module.exports = __webpack_public_path__ + "static/media/chutiki-icon.cc4594fd.png";